import { Controller } from '@hotwired/stimulus';
import { eventListener } from '@inked/utilities';

export class CounterController extends Controller {
  static targets = ['input'];
  static values = {
    step: {
      default: 1,
      type: Number,
    },
    setInputOnConnect: {
      type: Boolean,
      default: true,
    },
  };

  connect() {
    this.stopInputChangeEvent = eventListener(this.inputTarget, 'change', event => this.setInputValue(event.target.value));

    if (!this.setInputOnConnectValue) return;

    this.setInputValue(this.inputTarget.value, false);
  }

  disconnect() {
    this.stopInputChangeEvent();
  }

  countDigits() {
    return String(this.stepValue).includes('.')
      ? String(this.stepValue).split('.')[1].length
      : 0;
  }

  decrement() {
    this.setInputValue(this.value - this.stepValue);
  }

  increment() {
    this.setInputValue(this.value + this.stepValue);
  }

  setInputValue(value, dispatchEvent = true) {
    const newValue = Math.min(Math.max(value, this.min), this.max);

    this.inputTarget.value = newValue === 0 ? newValue : newValue.toFixed(this.countDigits());

    if (dispatchEvent) {
      this.inputTarget.dispatchEvent(new Event('input'));
    }
  }

  get max() {
    return this.inputTarget.hasAttribute('max') ? parseFloat(this.inputTarget.max) : Infinity;
  }

  get min() {
    return this.inputTarget.hasAttribute('min') ? parseFloat(this.inputTarget.min) : -Infinity;
  }

  get value() {
    return parseFloat(this.inputTarget.value) || 0;
  }
}
